import { Alert, AlertIcon, AlertText } from "@/components/ui/alert";
import { VStack } from "@/components/ui/vstack";
import { Info, TriangleAlert } from "lucide-react-native";
import {
  ComponentPropsWithoutRef,
  JSXElementConstructor,
  ReactElement,
  createContext,
  useContext,
  useMemo,
} from "react";
import { ActionItemType } from "./action.list.items";
import React from "react";
import { HStack } from "@/components/ui/hstack";

export const ActionListContext = createContext<{
  actions: Array<
    ReactElement<
      any,
      JSXElementConstructor<any> & { actionType: ActionItemType }
    >
  >;
}>({ actions: [] });

export function useActionListContext() {
  return useContext(ActionListContext);
}

export function ActionList(props: ComponentPropsWithoutRef<typeof Alert>) {
  const { actions } = useActionListContext();

  const [alertAction, alertIcon, alertTitle] = useMemo(() => {
    const types = new Set(actions.map((a) => a.type.actionType));

    if (types.has("TIPS_RESTRICTED") || types.has("PAYOUT_RESTRICTED")) {
      return [
        "error",
        TriangleAlert,
        <AlertText>Actions required</AlertText>,
      ] as const;
    }

    if (
      types.has("KYC") ||
      types.has("BENEFICIARY_UPDATE") ||
      types.has("PROFILE")
    ) {
      return [
        "warning",
        TriangleAlert,
        <AlertText>Actions required</AlertText>,
      ] as const;
    }

    return ["info", Info, <AlertText>Next steps</AlertText>] as const;
  }, [actions]);

  if (actions.length === 0) {
    return null;
  }

  return (
    <Alert
      action={alertAction}
      variant="solid"
      className="items-start"
      {...props}
    >
      <VStack className="gap-2 w-full">
        <HStack className="gap-2 justify-center">
          <AlertIcon as={alertIcon} />
          {alertTitle}
        </HStack>
        {actions.map((element) => (
          <React.Fragment key={element.type.actionType}>
            {element}
          </React.Fragment>
        ))}
      </VStack>
    </Alert>
  );
}
